import React, {
  useState,
  useEffect,
  useMemo,
  ReactNode,
  useContext,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Col,
  Card,
  Avatar,
  Row,
  Popover,
  Carousel,
  Pagination,
  Modal,
} from 'antd';
import Meta from 'antd/lib/card/Meta';
import Slider from 'react-slick';
import { useHistory } from 'react-router-dom';
import { History } from 'history';
import { FaStar, FaRegClock, FaMapMarkerAlt } from 'react-icons/fa';
import _ from 'lodash';
import { usePosition } from 'use-position';
import i18n from 'i18next';
import classnames from 'classnames';
import {
  getMealState,
  sortedMealsByDistance,
} from '../../../store/meals/selector';
import { Meal } from '../../../store/meals/types';
import { PlaceOrderHandler } from '../../orders/PlaceOrder';
import { OrderButton } from './OrderButton';
import {
  CenterProps,
  calcCrow,
  getScheduleDate,
  PopOverContent,
} from './DesktopMealCarousel';
import { getUserState } from '../../../store/user/selector';
import moment from 'moment';

import MealSearchImage from '../../../assets/images/png/swap/search_icon.png';
import DayPicker, { DayModifiers } from 'react-day-picker';
import { colors } from '../../../constants/colors';
import { getAdminState } from '../../../store/admin/selector';
import { getAnotherMeals, AccountTypeContext } from '../Dashboard';
import { AuthModalContent } from '../../layout/Header';

const BREAKFAST_TIME = '7 AM – 11 AM';
const LUNCH_TIME = '11 AM – 17 PM';
const DINNER_TIME = '17 PM – 23 PM';

export interface MealCardsParams {
  meal: Meal;
}

export const getScheduleTime = (scheduleTime: string | undefined) => {
  let time = '';
  switch (scheduleTime) {
    case 'a.m':
      time = BREAKFAST_TIME;
      break;
    case 'p.m':
      time = LUNCH_TIME;
      break;
    case 'Evening':
      time = DINNER_TIME;
      break;
    default:
      time = '';
  }
  return time;
};

export const TimeLocationDetails: React.FC<MealCardsParams> = ({ meal }) => {
  const { schedule, cookDetails } = meal;
  const getFirstSchedule = _.head(schedule);
  const getFirstScheduleTime = _.head(getFirstSchedule?.time);
  const time = getScheduleTime(getFirstScheduleTime);
  const [cooksLocation, setCooksLocation] = useState<CenterProps>();
  const settings = useMemo(
    () => ({ enableHighAccuracy: true, timeout: 0, maximumAge: Infinity }),
    []
  );

  const watch = true;
  const { latitude, longitude } = usePosition(watch, settings);

  const cookLocation = () => {
    if (cookDetails) {
      setCooksLocation({ ...cookDetails?.location });
    }
  };

  useEffect(cookLocation, [cookDetails]);
  const checkNoLocation =
    calcCrow(
      cooksLocation?.lat,
      cooksLocation?.lng,
      latitude,
      longitude
    ).toFixed(2) === NaN.toString();
  return (
    <div className="time-location-container">
      <div>
        <FaMapMarkerAlt size={14} color="#A8A8A8" />
        <span>
          {checkNoLocation
            ? `${meal.cookDetails?.address && meal.cookDetails?.address.city}`
            : `${calcCrow(
                cooksLocation?.lat,
                cooksLocation?.lng,
                latitude,
                longitude
              ).toFixed(2)} km`}
        </span>
      </div>
      <div>
        {time !== '' ? <FaRegClock size={15} color="#939393" /> : null}
        {time !== '' ? <span>{time}</span> : i18n.t('CONSTANT_OFFER')}
      </div>
    </div>
  );
};

export const CoverImageDetails: React.FC<MealCardsParams> = ({ meal }) => {
  const { cookDetails } = meal;
  const { ratings } = useSelector(getUserState);
  const checklength = ratings.filter(item => item.user === cookDetails?.id);
  const rate = ratings
    .filter(v => v.user === cookDetails?.id)
    .reduce((a, b) => a + b.rate / checklength.length, 0);
  return (
    <div
      className="meal-cover-image"
      style={{
        backgroundImage: `url(${meal.image})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="cover-image-overlay" />
      <div className="cover-image-top-items">
        <Link
          to={{
            pathname: '/userprofile/profile',
            state: cookDetails,
          }}
        >
          <div className="left-items">
            <Avatar src={cookDetails?.image} size="large" />
            <span>{cookDetails?.firstName}</span>
          </div>
        </Link>
        <div className="right-items">
          <FaStar color="#F7C82E" size={14} style={{ marginRight: 5 }} />
          {rate !== 0 ? rate : 'No Ratings'}
        </div>
      </div>
      {/* <div className="cover-image-bottom-items">
        <span>{`Kč ${meal.price}`}</span>
      </div> */}
    </div>
  );
};

export const MealItems: React.FC<MealCardsParams> = ({ meal }) => {
  const { schedule, stableoffer } = meal;
  const [visible, setVisibility] = useState(false);
  const { forWho } = useContext(AccountTypeContext);
  const { user } = useSelector(getUserState);
  const [selectedDays, setSelectedDays] = useState<(Date | undefined)[]>();
  const history: History = useHistory();

  const handleCancelPress = () => {
    Modal.destroyAll();
  };

  const handleLinkClick = (link: string) => (): void => {
    history.push(link);

    setTimeout(() => {
      Modal.destroyAll();
    }, 500);
  };

  const restrictionModalConfig = {
    icon: null,
    false: true,
    maskClosable: true,
    className: 'modal-content-container modal-content-description',
    okButtonProps: { style: { display: 'none' } },
    content: (
      <AuthModalContent
        onCreateAccountPress={handleLinkClick(
          `/authentication/registration/${forWho}`
        )}
        onLoginAccountPress={handleLinkClick(
          `/authentication/login/email/${forWho}`
        )}
        onPressCancel={handleCancelPress}
      />
    ),
  };

  const handleButtonClick = () => {
    if (user.userid) {
      PlaceOrderHandler({ meal, history });
      return;
    }
    Modal.info(restrictionModalConfig);
  };
  const handleVisibleChange = () => {
    setVisibility(!visible);
  };

  const validateDate = () => {
    const dates =
      getScheduleDate(schedule) &&
      getScheduleDate(schedule).map(
        (s: { time: string | any[]; date: any }) => {
          if (s.time && s.time.length) {
            return new Date(s.date.seconds * 1000);
          }
          return new Date(s.date.seconds * 1000); // remove if error
        }
      );
    setSelectedDays(dates);
  };

  const renderDay = (date: Date, modifiers: DayModifiers): ReactNode => {
    const customDate = new Date(date).getDate();
    return (
      <Popover
        key={customDate}
        content={<PopOverContent date={date} schedule={schedule} />}
        trigger="click"
      >
        <div>{customDate}</div>
      </Popover>
    );
  };

  const arrayHeaderMonths = [
    i18n.t('January'),
    i18n.t('February'),
    i18n.t('March'),
    i18n.t('April'),
    i18n.t('May'),
    i18n.t('June'),
    i18n.t('July'),
    i18n.t('August'),
    i18n.t('September'),
    i18n.t('October'),
    i18n.t('November'),
    i18n.t('December'),
  ];
  const content = (
    <div
      style={{
        padding: '20px',
        height: '380px',
        width: '330px',
      }}
    >
      {selectedDays && selectedDays.length > 0 ? (
        <DayPicker
          selectedDays={selectedDays}
          className="date-picker-container"
          months={arrayHeaderMonths}
          renderDay={renderDay}
        />
      ) : (
        <div className="popover-container">
          {stableoffer?.isChecked && (
            <div>
              <span style={{ color: colors.black }}>{`${i18n.t(
                'TIME_SCHEDULE'
              )}:`}</span>
              {stableoffer.time.map((t, i) => {
                const btnClass = classnames({
                  'popover-items': true,
                  'popover-items-active': true,
                });
                return (
                  <div key={i} className={btnClass}>
                    <span style={{ marginLeft: '10px' }}>
                      {t === 'a.m'
                        ? `${i18n.t(t)} - 7 AM – 11 AM`
                        : t === 'p.m'
                        ? `${i18n.t(t)} - 11 AM – 17 PM`
                        : `${i18n.t(t)} - 17 AM – 23 PM`}
                    </span>
                  </div>
                );
              })}
            </div>
          )}
          {/* <Row justify="center">
          <span>{i18n.t('NO_DATES')}</span>
        </Row> */}
        </div>
      )}
    </div>
  );
  useEffect(validateDate, [schedule]);
  return (
    <Card
      bordered={false}
      className="meal-cards-container"
      cover={<CoverImageDetails meal={meal} />}
    >
      <TimeLocationDetails meal={meal} />
      <Popover
        content={content}
        title={i18n.t('AVAILABLE_DATES')}
        trigger="click"
        visible={visible}
        onVisibleChange={handleVisibleChange}
        placement="bottom"
      >
        <Row justify="start" style={{ width: '100%', cursor: 'pointer' }}>
          <span style={{ color: colors.blue }}>{i18n.t('VIEW_DATES')}</span>
        </Row>
      </Popover>
      <Meta
        title={meal.title}
        description={meal.description}
        style={{ marginTop: '10px' }}
      />

      <OrderButton onClick={handleButtonClick} />
    </Card>
  );
};

export const getFilterData = (
  meals: any[],
  dataFilter: any,
  isMobile?: boolean
) => {
  const keywordFilter = isMobile
    ? meals.filter(meal =>
        meal.title.toLocaleLowerCase().includes(dataFilter.keyword)
      )
    : [];
  const catFilter = meals.filter(item => {
    const arr1 = item.category.filter((cat: any) => {
      return dataFilter.category.indexOf(cat) > -1;
    });
    if (arr1.length > 0) {
      return true;
    }
    return false;
  });
  const restFilter = meals.filter(item => {
    const arr1 = item.restrictions.filter((res: any) => {
      return dataFilter.restrictions.indexOf(res) > -1;
    });
    if (arr1.length > 0) {
      return true;
    }
    return false;
  });
  const consumptionFilter = meals.filter(
    item =>
      item.consumption === dataFilter.consumption ||
      Number(item.price) < Number(dataFilter.price)
  );
  const distanceFilter = meals.filter(
    item => item.distance / 1000 <= dataFilter.distance
  );
  const dateFilter = meals.filter(item => {
    const dates = item.schedule.filter(
      (cdate: { date: { seconds: number } }) => {
        return (
          moment(cdate.date.seconds * 1000).format('YYYY/MM/DD') >=
            moment(dataFilter.selectedDate.from).format('YYYY/MM/DD') &&
          moment(cdate.date.seconds * 1000).format('YYYY/MM/DD') <=
            moment(dataFilter.selectedDate.to).format('YYYY/MM/DD')
        );
      }
    );
    if (dates.length > 0) {
      return true;
    }
    return false;
  });
  const concatCategoryAndRestriction = catFilter.concat(restFilter);
  const concatConsump = concatCategoryAndRestriction.concat(consumptionFilter);
  const concatDistance = concatConsump.concat(distanceFilter);
  const concatDates = concatDistance.concat(dateFilter);

  const concatKeyword = concatDates.concat(keywordFilter);
  const mergeAndRemoveDuplicate = concatKeyword.filter((item, pos) => {
    return concatKeyword.indexOf(item) === pos;
  });

  return mergeAndRemoveDuplicate;
};

export const MealCarouselSelection: React.FC = () => {
  const { user, dataFilter } = useSelector(getUserState);
  const { meals, lastMealField } = useSelector(getMealState);
  const mealsSorted = useSelector(sortedMealsByDistance);
  const { advertisement } = useSelector(getAdminState);
  const filterData = getFilterData(mealsSorted, dataFilter, true);
  const [currentPage, setCurrentPage] = useState(1);
  const [mealsPerPage] = useState(28);
  const dispatch = useDispatch();
  // const Breakfast = [
  //   `${moment('07:00', 'HH:mm').format('HH:mm')}`,
  //   `${moment('11:00', 'HH:mm').format('HH:mm')}`,
  // ];
  // const Lunch = [
  //   `${moment('11:00', 'HH:mm').format('HH:mm')}`,
  //   `${moment('17:00', 'HH:mm').format('HH:mm')}`,
  // ];
  const Dinner = [
    `${moment('17:00', 'HH:mm').format('HH:mm')}`,
    `${moment('23:00', 'HH:mm').format('HH:mm')}`,
  ];

  const currentTime = moment().format('HH:mm');
  const isEndTime = currentTime > Dinner[1];
  const filterM = _.filter(
    filterData.length > 0 || dataFilter.isFilter ? filterData : mealsSorted,
    item => {
      let hasMeal = false;
      item.schedule.filter((sched: any, i: number) => {
        if (
          item.cook !== user.userid &&
          moment(sched.date.seconds * 1000).format('YYYY/MM/DD') ===
            moment().format('YYYY/MM/DD')
        ) {
          hasMeal = true;
        }
        return hasMeal;
      });
      if (
        item.cook !== user.userid &&
        item.stableoffer &&
        item.stableoffer.isChecked
      ) {
        hasMeal = true;
      }
      return hasMeal;
    }
  );

  const [newmeals, setNewMeals] = useState(filterM);

  // const afterChangeFunc = (currentSlide: any) => {
  //   if (newmeals.length - 1 === currentSlide && lastMealField) {
  //     getAnotherMeals(dispatch);
  //   }
  // };

  const handlePageChange = (page: number, pageSize: number | undefined) => {
    console.log(page);
    setCurrentPage(page);
  };

  const settings = {
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 1,
    infinite: false,
    arrows: false,
    centerMode: true,
    focusOnSelect: true,
    centerPadding: '30px',
    // afterChange: afterChangeFunc,
    responsive: [
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        },
      },
      {
        breakpoint: 770,
        settings: { slidesToShow: 1, slidesToScroll: 1, infinite: false },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerPadding: '60px',
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
          centerPadding: '60px',
        },
      },
    ],
  };

  useEffect(() => {
    if (meals) {
      const filterNewest = _.orderBy(
        isEndTime ? mealsSorted : filterM,
        'timeadded',
        'desc'
      );
      if (dataFilter.isFilter) {
        setNewMeals(filterM);
        return;
      }
      setNewMeals(filterNewest);
    }
  }, [meals, dataFilter]);

  const indexOfLastMeal = currentPage * mealsPerPage;
  const indexOfFirstMeal = indexOfLastMeal - mealsPerPage;
  const currentMeals = newmeals.slice(indexOfFirstMeal, indexOfLastMeal);
  // console.log(newmeals);
  return (
    <Col
      xs={24}
      sm={24}
      md={24}
      lg={24}
      // xl={10}
      className="meal-carousel-container"
    >
      {newmeals.length > 0 ? (
        <div style={{ flex: 1, height: '95%' }}>
          <Slider {...settings}>
            {currentMeals.map((item, i) => (
              <div key={i}>
                {i % 10 === 9 && advertisement && advertisement.length > 0 ? (
                  <Carousel
                    autoplay
                    effect="fade"
                    style={{ width: '100%', height: '460px' }}
                    dots={false}
                  >
                    {advertisement &&
                      advertisement
                        .filter(item => item.position === '10th')
                        .map((item, i) => (
                          <div
                            key={i}
                            onClick={() => window.open(item.siteUrl, '_blank')}
                          >
                            <div
                              style={{
                                backgroundImage: `url(${item.image})`,
                                backgroundPosition: 'center',
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                              }}
                              className="banner-image"
                            />
                          </div>
                        ))}
                  </Carousel>
                ) : (
                  <MealItems meal={item} />
                )}
              </div>
            ))}
          </Slider>
          <div style={{ marginTop: '25px' }}>
            <Pagination
              current={currentPage}
              defaultCurrent={1}
              total={newmeals.length}
              onChange={handlePageChange}
              pageSize={mealsPerPage}
            />
          </div>
        </div>
      ) : (
        <Row justify="center">
          <div className="cannot-find-meals">
            <img
              src={MealSearchImage}
              alt="Meal Search"
              style={{ width: 120, height: 120 }}
            />
            <span>{i18n.t('Cannot find offers')}</span>
          </div>
        </Row>
      )}
    </Col>
  );
};
